import * as React from 'react';
import clsx from 'clsx';
import { useIsSafari } from '@/hooks/useIsSafari';

type LayoutSignUpProps = {
	children: React.ReactNode;
	rightContent: React.ReactNode;
	classNameLeft?: string;
	classNameRight?: string;
};

export const LayoutSignUp: React.FC<LayoutSignUpProps> = ({
	children,
	rightContent,
	classNameLeft,
	classNameRight,
}) => {
	const { isSafari } = useIsSafari();

	return (
		<div className="w-full min-h-screen h-screen flex flex-col overflow-x-hidden bg-white">
			<div className="flex-1 overflow-y-auto">
				<div className="grid grid-cols-1 lg:grid-cols-2 w-full min-h-full">
					<div
						className={clsx(
							'flex flex-col items-center justify-start lg:justify-center',
							'lg:pt-safe-top px-6 lg:px-[84px] bg-white w-full -webkit-overflow-scrolling-touch',
							'overflow-y-auto md:overflow-y-hidden',
							{
								'pb-24 md:pb-6': isSafari,
								'pb-6': !isSafari,
							},
							classNameLeft
						)}
					>
						{children}
					</div>
					<div
						className={clsx('hidden lg:block overflow-y-auto', classNameRight)}
						style={{
							background:
								'linear-gradient(107.11deg, #EDE9F3 0%, #FFFFFF 100.5%)',
						}}
					>
						{rightContent}
					</div>
				</div>
			</div>
		</div>
	);
};
